import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services/local/authentication.service';

@Component({
  selector: 'app-sair',
  templateUrl:'./sair.component.html'
})
export class SairComponent implements OnInit {

  constructor(private router: Router, 
    private authenticationService: AuthenticationService) {}

  ngOnInit(): void {
    this.logout();
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/usuarios/login']);
  }

}
